import { warehouseClient } from "@/infrastructure/http/warehouseClient";
import type { InventoryMovementListResponse, ApiEnvelope } from "@/domain/types";

export async function listInventoryMovements(params: {
  page?: number;
  limit?: number;
  productId?: string;
  locationId?: string;
  warehouseId?: string;
  sourceType?: string;
  sourceId?: string;
  from?: string;
  to?: string;
  categoryId?: string;
}): Promise<InventoryMovementListResponse> {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.productId) query.set("productId", params.productId);
  if (params.locationId) query.set("locationId", params.locationId);
  if (params.warehouseId) query.set("warehouseId", params.warehouseId);
  if (params.sourceType) query.set("sourceType", params.sourceType);
  if (params.sourceId) query.set("sourceId", params.sourceId);
  if (params.from) query.set("from", params.from);
  if (params.to) query.set("to", params.to);
  if (params.categoryId) query.set("categoryId", params.categoryId);
  const response = await warehouseClient.get<ApiEnvelope<InventoryMovementListResponse>>(`/inventory-movement?${query.toString()}`);
  return response.data.data;
}
